module.exports = __webpack_public_path__ + "static/media/family.7118b341.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Images/family.png
// module id = 1072
// module chunks = 0